import { createReducer } from 'redux-create-reducer';
import { LOGIN_SUCCESS, LOGOUT } from 'modules/authentication/actions/authentication.ationTypes';

const initialState = {
  user: {},
  access_token: null,
  first_visit: true,
};

const events = {
  [LOGIN_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      ...payload,
      first_visit: false,
    };
  },
  [LOGOUT]: state => {
    return {
      ...initialState,
      first_visit: state?.first_visit === undefined ? true : state?.first_visit,
    };
  },
};

export default createReducer(initialState, events);
